import React, { useEffect } from "react";
import PageBanner from "../components/PageBanner/PageBanner";
import Footer from "../components/footer/footer";
import { AiOutlineCalendar, AiOutlineClockCircle, AiOutlineEnvironment } from "react-icons/ai";
import "./style/Events.css";

const Events = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el));
    
    return () => observer.disconnect();
  }, []);

  const upcomingEvents = [
    {
      title: "Orientation Week",
      date: "19 October 2026",
      time: "To be announced",
      location: "UDBS",
      type: "Orientation",
      description: "A week dedicated to welcoming freshers to UDIAA and introducing the association, its values, activities, and opportunities for growth.",
    },
    {
      title: "Internal Audit Symposium",
      date: "14 November 2026",
      time: "To be announced",
      location: "UDBS",
      type: "Symposium",
      description: "A flagship event bringing together students, professionals, and thought leaders to discuss key issues, trends, and the future of internal auditing.",
    },
    {
      title: "Industry Visit / Insights",
      date: "28 November 2026",
      time: "To be announced",
      location: "Sponsor venue",
      type: "Industry Visit",
      description: "A visit to one of our sponsors to gain firsthand insights into industry practices, operational processes, and career opportunities.",
    },
    {
      title: "Soft Skills Training Workshop",
      date: "12 December 2026",
      time: "To be announced",
      location: "UDBS C124",
      type: "Workshop",
      description: "A hands-on workshop to enhance essential soft skills such as communication, teamwork, problem solving, and leadership.",
    },
    {
      title: "AI and Other Emerging Trends",
      date: "9 January 2027",
      time: "To be announced",
      location: "UDBS",
      type: "Workshop",
      description: "Explore the impact of AI and other emerging technologies in internal audit and learn how to stay ahead in a dynamic world.",
    },
    {
      title: "Sports Day: UDIAA vs Sponsor",
      date: "23 January 2027",
      time: "To be announced",
      location: "To be announced",
      type: "Sports",
      description: "A friendly sports competition promoting fitness, teamwork, and stronger relationships with our sponsors.",
    },
    {
      title: "Study Visit to Sponsor",
      date: "6 February 2027",
      time: "To be announced",
      location: "Sponsor venue",
      type: "Study Visit",
      description: "An opportunity to learn, network, and gain practical exposure from one of our valued sponsors.",
    },
    {
      title: "Women in Internal Auditing",
      date: "13 March 2027",
      time: "To be announced",
      location: "UDBS",
      type: "Professional Development",
      description: "Celebrating and empowering women in the profession through inspiring talks, mentorship, and networking.",
    },
  ];

  const pastEvents = [
    {
      title: "Dinner gala",
      date: "2026",
      description: "Dinner Gala is a celebratory event where students come together to cherish their final university moments in a joyful and relaxed atmosphere. It is a time to reflect on shared experiences, celebrate achievements, and strengthen friendships while enjoying an evening filled with laughter, entertainment, and meaningful connections.",
    },
    {
      title: "Student Conference",
      date: "3 July 2026",
      description: "Student Conference is an interactive platform designed to connect students with industry professionals through engaging and insightful sessions. The conference features panel discussions, expert speakers, and open forums that encourage meaningful dialogue and knowledge sharing.",
    },
    {
      title: "Career Fair",
      date: "4 July 2026",
      description: "Career Fair is a dynamic event that brings together students and leading firms, creating a platform for direct engagement and opportunity. Participating organizations have the chance to interact with students, showcase their products and services, and highlight career pathways within their industries.",
    },
    {
      title: "EY Industry Insight",
      date: "8 May 2026",
      description: "Industry Insight is a dynamic study tour program that offers students the opportunity to explore real-world work environments and gain practical exposure beyond the classroom. Through guided visits and interactive sessions, students engage with industry professionals, learn about current practices and technologies, and develop a deeper understanding of how theoretical knowledge is applied in everyday operations.",
    },
    {
      title: "PWC Industry Insight",
      date: "15 May 2026",
      description: "Industry Insight is a dynamic study tour program that offers students the opportunity to explore real-world work environments and gain practical exposure beyond the classroom. Through guided visits and interactive sessions, students engage with industry professionals, learn about current practices and technologies, and develop a deeper understanding of how theoretical knowledge is applied in everyday operations.",
    },
    {
      title: "Deloitte Industry Insight",
      date: "2026",
      description: "Industry Insight is a dynamic study tour program that offers students the opportunity to explore real-world work environments and gain practical exposure beyond the classroom. Through guided visits and interactive sessions, students engage with industry professionals, learn about current practices and technologies, and develop a deeper understanding of how theoretical knowledge is applied in everyday operations.",
    },
    {
      title: "Inauguration Ceremony",
      date: "2023",
      description: "The official launch of UDIAA, bringing together students, faculty, and industry professionals."
    },
    {
      title: "IIA Tanzania Partnership Event",
      date: "2024",
      description: "Establishing our partnership with the Institute of Internal Auditors Tanzania."
    },
    {
      title: "Professional Development Seminar",
      date: "2024",
      description: "A series of seminars focused on skill development and career preparation."
    },
  ];

  return (
    <div className="events-page">
      <PageBanner 
        title="Events"
        subtitle="Discover our exciting events and opportunities to grow professionally"
        breadcrumbs={[{ label: "Events" }]}
      />

      {/* Upcoming Events */}
      <section className="events-section section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Upcoming</span>
            <h2 className="section-title">Upcoming Events</h2>
            <p className="section-subtitle">
              Mark your calendar for the 2026–2027 UDIAA programme.
            </p>
          </div>

          <div className="events-programme">
            <aside className="events-poster-card">
              <img src="/events/udiaa-calendar-2026-2027.jpg" alt="UDIAA 2026–2027 events calendar" />
              <p>Same mission. Bigger impact.</p>
            </aside>

            <div className="events-grid">
              {upcomingEvents.map((event) => (
                <article className="event-card" key={`${event.date}-${event.title}`}>
                  <div className="event-type">{event.type}</div>
                  <h3>{event.title}</h3>
                  <p className="event-description">{event.description}</p>
                  <div className="event-details">
                    <div className="event-detail">
                      <AiOutlineCalendar />
                      <span>{event.date}</span>
                    </div>
                    <div className="event-detail">
                      <AiOutlineClockCircle />
                      <span>{event.time}</span>
                    </div>
                    <div className="event-detail">
                      <AiOutlineEnvironment />
                      <span>{event.location}</span>
                    </div>
                  </div>
                  <span className="event-save-date">Save the date</span>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Past Events */}
      <section className="past-events-section section animate-on-scroll">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Past Events</span>
            <h2 className="section-title">Our Journey So Far</h2>
          </div>

          <div className="timeline">
            {pastEvents.map((event, index) => (
              <div className="timeline-item" key={index}>
                <div className="timeline-marker"></div>
                <div className="timeline-content">
                  <span className="timeline-date">{event.date}</span>
                  <h3>{event.title}</h3>
                  <p>{event.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="events-cta-section section animate-on-scroll">
        <div className="container">
          <div className="events-cta-card">
            <h2>Want to Organize an Event?</h2>
            <p>
              Have an idea for a workshop, seminar, or networking event? 
              We'd love to hear from you and help make it happen.
            </p>
            <a href="/contacts" className="events-cta-btn">
              Get In Touch
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Events;
